// extracted by mini-css-extract-plugin
module.exports = {"AllOrders":"Orders_AllOrders__32Epo","Empty":"Orders_Empty__ib2py"};